import React from 'react';
import { Container } from '@plone/components';
import DataTable from 'react-data-table-component';

const mainColumns = [
  {
    name: 'Data do Repasse',
    selector: (row) => row.title,
    format: (row, index) => <span className="title main">{row.title}</span>,
  },
  {
    name: 'Repasse previsto',
    selector: (row) => row.previsto,
    format: (row, index) => <span className="value main"></span>,
    right: true,
  },
  {
    name: 'Repasse arrecadado',
    selector: (row) => row.total,
    format: (row, index) => <span className="value main"></span>,
    right: true,
  },
  {
    name: 'Repasse devolvido',
    selector: (row) => row.devolvido,
    format: (row, index) => <span className="value main"></span>,
    right: true,
  },
  {
    name: 'Repasse a devolver',
    selector: (row) => row.adevolver,
    format: (row, index) => <span className="value main"></span>,
    right: true,
  },
];

const detalheColumns = [
  {
    name: 'Data do Repasse',
    selector: (row) => row.data,
    format: (row, index) => <span className="title detail">{row.data}</span>,
  },
  {
    name: 'Repasse previsto',
    selector: (row) => row.previsto,
    format: (row, index) => (
      <span className="value detail">{row.previsto}</span>
    ),
    right: true,
  },
  {
    name: 'Repasse arrecadado',
    selector: (row) => row.valor,
    format: (row, index) => <span className="value detail">{row.valor}</span>,
    right: true,
  },
  {
    name: 'Repasse devolvido',
    selector: (row) => row.devolvido,
    format: (row, index) => (
      <span className="value detail">{row.devolvido}</span>
    ),
    right: true,
  },
  {
    name: 'Repasse a devolver',
    selector: (row) => row.adevolver,
    format: (row, index) => (
      <span className="value detail">{row.adevolver}</span>
    ),
    right: true,
  },
];

const DetalhesMensal = ({ data }) => {
  const conditionalRowStyles = [
    {
      when: (row) => row.is_total === true,
      style: {
        fontWeight: 'bold',
      },
    },
  ];
  return (
    <div>
      {data.repasses.length > 0 ? (
        <DataTable
          columns={detalheColumns}
          data={data.repasses}
          noTableHead
          conditionalRowStyles={conditionalRowStyles}
        />
      ) : (
        <span>Sem dados</span>
      )}
    </div>
  );
};

const Repasses = ({ repasses }) => {
  return (
    <Container className={'tabela'} narrow>
      <DataTable
        columns={mainColumns}
        data={repasses}
        expandableRows
        expandableRowsComponent={DetalhesMensal}
        expandableRowExpanded={(row) => true}
        expandableRowDisabled={(row) => row.repasses.length === 0}
      />
    </Container>
  );
};

export default Repasses;
